export enum WhatsappCloudApiLoginEventEnum {
  FINISH = 'FINISH',
  CANCEL = 'CANCEL',
  ERROR = 'ERROR',
  MIGRATED_WITH_LIMITATIONS = 'MIGRATED_WITH_LIMITATIONS',
}
